var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',_vm._b({attrs:{"icon":`${_vm.theme} ${_vm.icon}`}},'font-awesome-icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }